import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import IconButton, { type IconButtonProps } from '@mui/material/IconButton';
import Tooltip, { type TooltipProps } from '@mui/material/Tooltip';
import React from 'react';

export interface InfoTooltipTriggerProps extends Omit<IconButtonProps, 'children' | 'aria-label'> {
  /** תוכן הטולטיפ */
  tooltipTitle: TooltipProps['title'];
  /** תווית נגישות לכפתור */
  ariaLabel: string;
  arrow?: boolean;
  placement?: TooltipProps['placement'];
  enterDelay?: TooltipProps['enterDelay'];
  enterTouchDelay?: TooltipProps['enterTouchDelay'];
  /** מועבר ל־Tooltip */
  tooltipSlotProps?: TooltipProps['slotProps'];
}

/**
 * טריגר מידע אחיד: גודל וצבע מהערכת בלבד (אל תגדירו fontSize על האייקון ב־sx).
 * ב־RTL: שימו אחרי הטקסט ב־DOM — האייקון יופיע משמאל לכותרת.
 */
export default function InfoTooltipTrigger({
  tooltipTitle,
  ariaLabel,
  arrow = true,
  placement = 'top',
  enterDelay,
  enterTouchDelay,
  tooltipSlotProps,
  size = 'small',
  ...iconButtonProps
}: InfoTooltipTriggerProps) {
  return (
    <Tooltip
      title={tooltipTitle}
      arrow={arrow}
      placement={placement}
      enterDelay={enterDelay}
      enterTouchDelay={enterTouchDelay}
      slotProps={tooltipSlotProps}
    >
      <IconButton size={size} aria-label={ariaLabel} {...iconButtonProps}>
        <InfoOutlinedIcon />
      </IconButton>
    </Tooltip>
  );
}
